import { Entity, Fields, Allow } from "remult";

@Entity("member", {
    allowApiRead: Allow.authenticated,
    allowApiCrud: false
})
export class Member {
    @Fields.string()
    id = "";

    @Fields.string({ dbName: "user_id" })
    userId?: string;

    @Fields.string({ dbName: "organization_manager_id" })
    organizationManagerId?: string;
}
